import { createSlice } from '@reduxjs/toolkit';
import { IBlackFridayState } from '../../types/blackFriday';

const initialState: IBlackFridayState = {
  promoDatesText: '',
};

export const blackFridaySlice = createSlice({
  name: 'blackFriday',
  initialState,
  reducers: {},
});

export const { reducer: blackFridayReducer } = blackFridaySlice;
